// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1xTqF","resendInfoText":"OnGoingPaymentBox_resendInfoText__fjxXS"};